import clsx from "clsx";

import { SubmissionModel } from "@interfaces/index";
import { formatAmount } from "@utils/index";
import {
  CreditCardRefundSvg,
  CreditCardPaySvg,
  TaxPoundSvg,
} from "@components/index";

export const SubmissionKpiPanel = ({
  submissionDetails,
  puEnabled,
  disabledFeatures,
}: {
  submissionDetails?: SubmissionModel;
  puEnabled: boolean;
  disabledFeatures: string[];
}) => (
  <div
    className="flex flex-col md:ml-10 md:flex-row"
    data-testid="submissionDetails_kpi"
  >
    <div className="flex min-w-[200px] items-center justify-between rounded-t-lg bg-white-100 px-4 py-3 md:rounded-e-none md:rounded-s-lg">
      <div className="text-green-100 opacity-70">Income:</div>
      <div className="flex items-center gap-x-2 font-bold text-green-100">
        {formatAmount(submissionDetails?.income)}
        <CreditCardRefundSvg />
      </div>
    </div>
    <div className="mt-px flex min-w-[207px] items-center justify-between bg-white-100 px-4 py-3 md:ml-px md:mt-0 md:py-2">
      <div className="text-black-54">
        {submissionDetails?.userBusiness.type === "landlord"
          ? "Expenses"
          : "Business"}
        :
      </div>
      <div className="flex items-center gap-x-2 font-bold text-black-100">
        {formatAmount(submissionDetails?.business)}
        <div className="text-black-54">
          <CreditCardPaySvg />
        </div>
      </div>
    </div>
    {puEnabled && !disabledFeatures.includes("Private Use") && (
      <div className="mt-px flex min-w-[194px] items-center justify-between bg-white-100 px-4 py-3 md:ml-px md:mt-0 md:py-2">
        <div className="text-black-54">Private:</div>
        <div className="flex items-center gap-x-2 font-bold text-black-100">
          {formatAmount(submissionDetails?.private)}
          <div className="text-black-54">
            <CreditCardPaySvg />
          </div>
        </div>
      </div>
    )}
    <div className="mt-1 flex min-w-[220px] items-center justify-between rounded-b-lg bg-white-100 px-4 py-3 md:ml-1 md:mt-0 md:rounded-b-none md:rounded-r-lg md:py-2">
      <div className="text-black-54">Profit/Loss:</div>
      <div className="flex items-center gap-x-2 font-bold text-black-100">
        <span
          className={clsx(
            submissionDetails?.profit[0] === "-"
              ? "text-red-100"
              : "text-green-100",
          )}
        >
          {formatAmount(submissionDetails?.profit)}
        </span>
        <div className="text-black-54">
          <TaxPoundSvg />
        </div>
      </div>
    </div>
  </div>
);
